var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "300pt",
    height: "300pt",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 25.128906 142.570313 L 199.984375 92.753906 L 223.523438 175.371094 L 185.054688 155.636719 L 192.90625 184.09375 L 154.3125 164.089844 L 162.292969 192.816406 L 123.40625 171.972656 L 131.679688 201.539063 L 92.988281 181.558594 L 101.0625 210.261719 L 62.121094 190.660156 L 70.449219 218.984375 L 31.742188 199.316406 L 18.96875 153.574219 C 17.648438 148.835938 20.402344 143.921875 25.128906 142.570313 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 280.246094 131.066406 L 271.703125 101.445313 C 269.617188 94.210938 264.824219 88.214844 258.210938 84.5625 C 251.597656 80.90625 243.96875 80.042969 236.734375 82.128906 L 210.210938 89.78125 L 217.398438 115.269531 L 244.070313 107.578125 C 244.242188 107.527344 244.40625 107.507813 244.558594 107.511719 C 244.90625 107.515625 245.199219 107.628906 245.40625 107.746094 C 245.703125 107.910156 246.097656 108.222656 246.257813 108.785156 L 254.800781 138.40625 C 254.964844 138.964844 254.800781 139.441406 254.632813 139.738281 C 254.46875 140.039063 254.152344 140.429688 253.59375 140.589844 L 226.722656 148.339844 L 233.910156 173.832031 L 260.933594 166.039063 L 260.929688 166.039063 C 268.164063 163.953125 274.164063 159.160156 277.816406 152.546875 C 281.46875 145.929688 282.332031 138.300781 280.246094 131.066406 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaw);
export default __webpack_public_path__ + "static/media/Saw.8fee6da5fe13192937d6bdd209f4b1a2.svg";
export { ForwardRef as ReactComponent };